import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/hospitalTypes';

export const fetchHospitalProfile = (data?: any, onSuccess: any = (): any => { }, onError: any = (): any => { }): Action<any> => {
  return updateAction(actionTypes.HOSPITAL_PROFILE, { data, onSuccess, onError });
};
export const fetchAdminSwitch = (data?: any): Action<any> => {
  return updateAction(actionTypes.FETCH_ADMIN_SWITCH, { data });
};
export const fetchEnableDisable = (data?: any): Action<any> => {
  return updateAction(actionTypes.FETCH_ENABLE_DISABLE_CLICK, { data });
};
export const fetchHospitalProfileData = (reqData: any): Action<any> => {
  return updateAction(actionTypes.HOSPITAL_PROFILE_DATA, reqData);
};
export const setIsLogOutClicked = (isLogOutClicked: any): Action<any> => {
  return updateAction(actionTypes.IS_LOGOUT_CLICKED, isLogOutClicked);
};

export const setNewEntry = (reqData: any): Action<any> => {
  return updateAction(actionTypes.SET_NEW_ENTRY, reqData);
};

export const fetchCalendar = (reqData: any): Action<any> => {
  return updateAction(actionTypes.FETCH_CALENDAR, reqData);
};

export const fetchCalendarEvents = (reqData: any): Action<any> => {
  return updateAction(actionTypes.FETCH_CALENDAR_EVENT, reqData);
};

export const fetchHospitalLogo = (reqData: any): Action<any> => {
  return updateAction(actionTypes.FETCH_HOSPITAL_LOGO, reqData);
};

export const hospitalLogo = (reqData: any): Action<any> => {
  return updateAction(actionTypes.HOSPITAL_LOGO, reqData);
};

export const fetchInfraImages = (reqData: any): Action<any> => {
  return updateAction(actionTypes.FETCH_INFRA_IMAGES, reqData);
};

export const infraImages = (reqData: any): Action<any> => {
  return updateAction(actionTypes.INFRA_IMAGES, reqData);
};

export const fetchIPInclusionMaster = (): Action<any> => {
  return updateAction(actionTypes.FETCH_IP_INCLUSION_MASTER);
};

export const fetchIPInclusionMasterData = (reqData: any): Action<any> => {
  return updateAction(actionTypes.IP_INCLUSION_MASTER_DATA, reqData);
};
export const fetchIPDepartmentMaster = (): Action<any> => {
  return updateAction(actionTypes.FETCH_IP_DEPARTMENT_MASTER);
};

export const fetchIPDepartmentMasterData = (reqData: any): Action<any> => {
  return updateAction(actionTypes.IP_DEPARTMENT_MASTER_DATA, reqData);
};

export const fetchDayCareDepartmentMaster = (): Action<any> => {
  return updateAction(actionTypes.FETCH_DAYCARE_DEPARTMENT_MASTER);
};

export const fetchDayCareDepartmentMasterData = (reqData: any): Action<any> => {
  return updateAction(actionTypes.DAYCARE_DEPARTMENT_MASTER_DATA, reqData);
};

export const fetchDayCareInclusionMaster = (): Action<any> => {
  return updateAction(actionTypes.FETCH_DAYCARE_INCLUSION_MASTER);
};

export const fetchDayCareInclusionMasterData = (reqData: any): Action<any> => {
  return updateAction(actionTypes.DAYCARE_INCLUSION_MASTER_DATA, reqData);
};

export const fetchAmenityMaster = (): Action<any> => {
  return updateAction(actionTypes.FETCH_AMENITY_MASTER);
};

export const fetchAmenityMasterData = (reqData: any): Action<any> => {
  return updateAction(actionTypes.AMENITY_MASTER_DATA, reqData);
};

export const getPatientVisitDetails = (payload: any, onSuccess: any, onError: any, isVisitsEnabled?: boolean): Action<any> =>
  updateAction(actionTypes.GET_PATIENT_VISIT_DETAILS, {payload, isVisitsEnabled,  onSuccess, onError});

export const setHISCardSelected = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_HIS_CARD_SELECTED, payload);

export const setIsHISClaim = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_IS_HIS_CLAIM, payload);

export const getPatientAllVisitsDetails = (payload: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.GET_PATIENT_ALL_VISITS_DETAILS, {payload, onSuccess, onError});

export const setHospitalPatientSearchDetails = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_PATIENT_LIST , payload);

export const setHISCardDisplayParameters = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_HIS_CARD_DISPLAY_PARAMETERS, payload);

export const setPatientSearchDetail = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_SELECTED_PATIENT_DATA, payload);

export const setSuggestedValuesMap = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_SUGGESTED_VALUES_MAP, payload);

export const setHospitalSearchValues = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_HOSPITAL_SEARCH_VALUES, payload);

export const getHISDoctorsList = (payload: any): Action<any> =>
 updateAction(actionTypes.GET_HIS_DOCTORS_LIST, payload);

export const setHISDoctorList = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_HIS_DOCTOR_LIST, payload);

export const setIsLogOutBtnClicked = (isLogOutBtnClicked: any): Action<any> => {
  return updateAction(actionTypes.IS_LOGOUT_BTN_CLICKED, isLogOutBtnClicked);
};

export const getTickerConfig = (providerId: any, onSuccess: any = (): any => { }, onError: any = (): any => {}): Action<any> => (
  updateAction(actionTypes.GET_TICKER_CONFIGURATION, { providerId, onSuccess, onError }));

export const setIsUserEmailVerified = (payload: boolean): Action<any> => {
  return updateAction(actionTypes.SET_IS_USER_EMAIL_VERIFIED, payload);
};
export const updateHospitalSeal = (fileGuid: any, propertyName: any): Action<any> =>
  updateAction(actionTypes.UPDATE_HOSPITAL_SEAL, {fileGuid, propertyName});

export const setAutomatedNewAdmission = (payload: boolean): Action<any> => {
  return updateAction(actionTypes.SET_IS_AUTOMATED_NEW_ADMISSION, payload);
};

export const setHISTreatmentValuesFromLookUp = (payload: any): Action<any> => {
  return updateAction(actionTypes.SET_HIS_TREATMENT_DETAILS, payload);
};

export const setIsHISPackageFilled = (payload: boolean): Action<any> => {
  return updateAction(actionTypes.SET_IS_HIS_PACKAGE_FILLED, payload);
};

export const setParsedHISValuesMap = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_PARSED_HIS_VALUES_MAP, payload);
